import { Card, CardProps } from "antd";
import { FC } from "react";

type SimpleCardProps = CardProps

const SimpleCard: FC<SimpleCardProps> = ({ title, bordered, children, className, style, ...rest }) => {
  return (
    <Card style={{ boxShadow: "none", ...style }} className={className} bodyStyle={{ padding: 16 }} type="inner" title={null} {...rest}>
      {title && (
        <h3 className="text-normal" style={{ fontSize: 14 }}>{title}</h3>
      )}
      {children}
    </Card>
  );
};

export default SimpleCard;
